import {MODALITY} from '@domain/model/Account/Subscription/Subscription';

export const FREQUENCY_DAY_SELECTOR = {
  [MODALITY.MONTHLY]: 'account.frequency.date_selector_monthly',
  [MODALITY.BIMONTHLY]: 'account.frequency.date_selector_bimonthly',
  [MODALITY.QUARTERLY]: 'account.frequency.date_selector_3month',
} as const;

export type RecurrentModalities = keyof typeof FREQUENCY_DAY_SELECTOR;
